import 'babel-polyfill';
import promise from 'es6-promise';
promise.polyfill();
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import uxkit from 'jimi-uxkit/packages/index.js';
import 'element-ui/packages/theme-chalk/src/index.scss';
import 'jimi-uxkit/packages/styles/index.scss';

Vue.use(uxkit, {
  i18n: (key, value) => i18n.t(key, value)
});

import './assets/css/base.css'; // 初始化样式
import axios from './http/http'; // http请求
import api from '@a'; // api接口
import MyComponents from '@c'; // 自定义封装组件集合
import options from '@l/options.js'; // 各种选项配置文件
import rules from '@l/rules.js'; // 各表单验证规则
import method from '@l/method.js'; // 公共方法
import Cookies from 'js-cookie'; // cookie插件
import i18n from '@/i18n/index.js';
import "./filters"

import directives from "@/directives";

Vue.prototype.$loadLanguageAsync(Cookies.get('locale')).finally(() => {
  Vue.use(MyComponents);

  Object.keys(method).forEach((key) => {
    Vue.prototype[`$${key}`] = method[key];
  });

  Vue.prototype.$axios = axios;
  Vue.prototype.$api = api;
  Vue.prototype.$opt = options();
  Vue.prototype.$rul = rules;
  Vue.prototype.$cookie = Cookies;
  Vue.prototype.$uxSdk = uxkit.uxSdk;

  /**
   * 重置全局uxLoading 要默认带文字
   */
  const uxLoading = Vue.prototype.$uxLoading;
  const fnShow = uxLoading.show;
  uxLoading.show = (params) => {
    fnShow({
      showText: true,
      text: 'loading...',
      ...params
    });
  };
  Vue.prototype.$uxLoading = uxLoading;

  Vue.config.productionTip = false;
  new Vue({
    router,
    i18n,
    store,
    render: (h) => h(App)
  }).$mount('#app');
});
